// frontend/src/pages/NewUIRegistrationSuccess.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Botón gaming reutilizable
function GamingButton({ variant = "secondary", className = "", leftIcon, children, disabled, ...props }) {
    const base =
        "inline-flex items-center justify-center gap-2.5 " +
        "h-12 md:h-14 px-6 md:px-8 " +
        "rounded-[14px] md:rounded-[16px] " +
        "font-bold tracking-wider leading-none " +
        "transition-transform duration-150 hover:scale-[1.02] active:scale-[0.98] " +
        "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100";

    const variants = {
        primary: "bg-accent text-secondary hover:bg-accent-light border-2 border-accent-dark",
        secondary: "bg-primary text-white hover:bg-primary-light border-2 border-primary-dark",
        ctaBlue: "bg-[#2284DF] text-white hover:bg-[#2A91F4] border-2 border-[#1E75C6]",
        ctaYellow: "bg-[#FCE503] text-[#122436] hover:bg-[#FCE503]/90 border-2 border-[#E5CF03]",
    };

    return (
        <button
            className={`${base} ${variants[variant]} ${className}`}
            disabled={disabled}
            {...props}
        >
            {leftIcon && <span className="inline-flex items-center">{leftIcon}</span>}
            <span className="whitespace-nowrap">{children}</span>
        </button>
    );
}

const NewUIRegistrationSuccess = () => {
    // Aplicar scope de Acumin
    useEffect(() => {
        document.body.classList.add('acumin-scope');
        return () => {
            document.body.classList.remove('acumin-scope');
        };
    }, []);

    return (
        <div
            className="min-h-screen flex items-center justify-center pt-24 pb-12 px-4 sm:px-6 lg:px-8"
            style={{
                backgroundImage: 'url(/images/backgrounds/hero-radial-bg.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="w-full max-w-lg">
                {/* Logo/Header */}
                <div className="text-center mb-8">
                    <Link to="/" className="inline-block">
                        <h1
                            className="toon toon-3d text-4xl md:text-5xl font-extrabold uppercase"
                            style={{
                                WebkitTextStroke: "1px #000",
                                textShadow: "0 2px 0 rgba(0,0,0,1), 0 4px 2px rgba(0,0,0,1)"
                            }}
                        >
                            Mano Ganadora
                        </h1>
                    </Link>
                </div>

                {/* Success Card */}
                <div
                    className="rounded-[24px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
                    style={{
                        backgroundColor: '#122436',
                        border: '2px solid rgba(255,255,255,0.55)'
                    }}
                >
                    <div className="px-6 sm:px-8 py-10 text-center">
                        {/* Success Icon */}
                        <div className="mb-6 flex justify-center">
                            <div
                                className="w-20 h-20 rounded-full flex items-center justify-center"
                                style={{
                                    backgroundColor: 'rgba(252, 229, 3, 0.15)',
                                    border: '3px solid #FCE503'
                                }}
                            >
                                <svg
                                    className="w-10 h-10 text-[#FCE503]"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={3}
                                        d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* Title */}
                        <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-4 uppercase tracking-wider">
                            ¡Registro Exitoso!
                        </h2>

                        {/* Message */}
                        <p className="text-white/80 mb-6 leading-relaxed">
                            Te hemos enviado un email de verificación.
                            Por favor revisá tu bandeja de entrada y seguí las instrucciones
                            para verificar tu cuenta.
                        </p>

                        {/* Info Box */}
                        <div
                            className="rounded-lg p-4 mb-8 text-left"
                            style={{
                                backgroundColor: 'rgba(34, 132, 223, 0.15)',
                                border: '2px solid #2284DF'
                            }}
                        >
                            <div className="flex items-start gap-3">
                                <svg
                                    className="w-5 h-5 text-[#2284DF] mt-0.5 shrink-0"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <div>
                                    <p className="text-sm font-bold text-white/90 mb-1">
                                        IMPORTANTE
                                    </p>
                                    <p className="text-sm text-white/75">
                                        Si no recibís el email en unos minutos, por favor revisá tu carpeta de spam.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* CTA Button */}
                        <Link to="/login" className="block mb-4">
                            <GamingButton
                                variant="ctaYellow"
                                className="w-full text-base uppercase"
                            >
                                Ir al Login
                            </GamingButton>
                        </Link>

                        {/* Support Link */}
                        <p className="text-sm text-white/60">
                            ¿Necesitás ayuda?{' '}
                            <a
                                href="#"
                                className="font-bold text-[#2284DF] hover:text-[#2A91F4] transition-colors"
                            >
                                Contactá soporte
                            </a>
                        </p>
                    </div>
                </div>

                {/* Back to home link */}
                <div className="mt-6 text-center">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors font-semibold"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                        Volver al inicio
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NewUIRegistrationSuccess;